import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTransition, animated } from "react-spring";

import { SidebarContent } from "./SidebarContent";

export function Sidebar({ isBranded, isOpen, closeSidebar, logout }) {
    const transitions = useTransition(isOpen, null, {
        from: {
            zIndex: 11,
            position: "fixed",
            top: 0,
            bottom: 0,
            right: 0,
            transform: "translateX(100%)"
        },
        enter: { transform: "translateX(0%)" },
        leave: { transform: "translateX(100%)" }
    });

    return (
        <>
            <Overlay isOpen={isOpen} onClick={closeSidebar}></Overlay>
            {transitions.map(
                ({ item, key, props }) =>
                    item && (
                        <animated.div key={key} style={props} data-testid="animated-sidebar">
                            <SidebarContent
                                logout={logout}
                                hideBar={closeSidebar}
                                isBranded={isBranded}
                            />
                        </animated.div>
                    )
            )}
        </>
    );
}

const Overlay = styled.div`
    z-index: ${props => (props.isOpen ? "10" : "1")};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: ${props => (props.isOpen ? "1" : "0")};
    visibility: ${props => (props.isOpen ? "visible" : "hidden")};
    transition: all 0.3s ease-out;
    background-color: rgba(0, 0, 0, 0.3);

    @media (prefers-reduced-motion) {
        transition: none;
    }
`;

Sidebar.propTypes = {
    isBranded: PropTypes.bool,
    isOpen: PropTypes.bool,
    closeSidebar: PropTypes.func,
    logout: PropTypes.func
};
